import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import "./FeaturedClasses.css";

const cardContent = [
  {
    name: "Cycling",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod…",
    img:
      "https://radiustheme.com/demo/wordpress/gymedge/wp-content/uploads/2016/12/class_05-410x200.jpg",
  },
  {
    name: "Martial Arts",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod…",
    img:
      "https://images.unsplash.com/photo-1555597408-26bc8e548a46?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bWFydGlhbCUyMGFydHN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    name: "Meditation",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod…",
    img:
      "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8bWVkaXRhdGlvbnxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    name: "Karate",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod…",
    img:
      "https://images.unsplash.com/photo-1601878458462-487dd38a06f1?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8a2FyYXRlJTIwa2lja3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    name: "Yoga",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod…",
    img:
      "https://images.unsplash.com/photo-1575052814086-f385e2e2ad1b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8eW9nYXxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    name: "Running",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod…",
    img:
      "https://images.unsplash.com/photo-1551927336-09d50efd69cd?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjV8fHJ1bm5pbmd8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
];

const FeaturedClasses = () => {
  return (
    <div className="featured_class_bg">
      <Container>
      <div className="text-center">
        <h2 className="pt-5">OUR FEATURED CLASSES</h2>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolor
          laboriosam, laborum laudantium ab tenetur cupiditate? At illo
          accusamus eaque officia quos pariatur id facilis et quo cumque
          repellat, ipsum corrupti?
        </p>
      </div>

      <Row>
        {cardContent.map((data, i) => {
          return (
            <Col xs={12} sm={6} md={4}>
              <Card className="m-2">
                <Card.Img style={{maxWidth:'400px',height:'200px'}} variant="top" src={data?.img} />
                <Card.Body>
                  <Card.Title>{data.name}</Card.Title>
                  <Card.Text>{data.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </Container>
    </div>
  );
};

export default FeaturedClasses;
